export default __webpack_public_path__ + "static/media/Frame 231.53385093.png";